import React from 'react';
import { Link } from 'react-router-dom';
import { companyInfo } from '../data';
import { LocationIcon, PhoneIcon, MailIcon, LinkedInIcon, FacebookIcon, InstagramIcon, TikTokIcon } from './Icons';

const Footer = () => {
    return (
        <footer className="footer">
            <div className="container">
                <div className="footer__grid">
                    <div className="footer__brand">
                        <div className="footer__logo">
                            <img src="/logo-phoenix-ai.png" alt="Phoenix AI" className="footer__logo-img" />
                            <span className="footer__logo-text">Phoenix<span>AI</span></span>
                        </div>
                        <p className="footer__description">
                            {companyInfo.tagline}. 
                            Malaysia-based AI solutions provider (Sdn Bhd, Reg: 1631340-A). ISO 27001 & GDPR certified.
                        </p>
                        <div className="footer__social">
                            <a href={companyInfo.social.linkedin} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="LinkedIn">
                                <LinkedInIcon size={20} />
                            </a>
                            <a href={companyInfo.social.facebook} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Facebook">
                                <FacebookIcon size={20} />
                            </a>
                            <a href={companyInfo.social.instagram} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="Instagram">
                                <InstagramIcon size={20} />
                            </a>
                            <a href={companyInfo.social.tiktok} target="_blank" rel="noopener noreferrer" className="footer__social-link" aria-label="TikTok">
                                <TikTokIcon size={20} />
                            </a>
                        </div>
                    </div>

                    <div className="footer__column">
                        <h4 className="footer__title">Company</h4>
                        <ul className="footer__links">
                            <li><Link to="/about" className="footer__link">About Us</Link></li>
                            <li><Link to="/services" className="footer__link">Services</Link></li>
                            <li><Link to="/contact" className="footer__link">Contact</Link></li>
                        </ul>
                    </div>

                    <div className="footer__column">
                        <h4 className="footer__title">Services</h4>
                        <ul className="footer__links">
                            <li><Link to="/services#training" className="footer__link">AI Training</Link></li>
                            <li><Link to="/services#iso27001" className="footer__link">ISO 27001 Consultancy</Link></li>
                            <li><Link to="/services#iso9001" className="footer__link">ISO 9001 Consultancy</Link></li>
                            <li><Link to="/services#cctv" className="footer__link">AI Powered CCTV</Link></li>
                        </ul>
                    </div>

                    <div className="footer__column">
                        <h4 className="footer__title">Contact</h4>
                        <div className="footer__contact">
                            <p className="footer__contact-name">{companyInfo.name}</p>
                            <div className="footer__contact-item">
                                <LocationIcon size={18} className="footer__contact-icon" />
                                <span className="footer__link">{companyInfo.address.full}</span>
                            </div>
                            <div className="footer__contact-item">
                                <PhoneIcon size={18} className="footer__contact-icon" />
                                <span className="footer__link">{companyInfo.phone}</span>
                            </div>
                            <div className="footer__contact-item">
                                <MailIcon size={18} className="footer__contact-icon" />
                                <span className="footer__link">{companyInfo.email}</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="footer__bottom">
                    <p className="footer__copyright">
                        © {new Date().getFullYear()} {companyInfo.name}. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
